import { h, svgUse } from '../utils/dom.js';
import { t } from '../i18n/index.js';
import { Card } from '../components/common/Card.js';

export function ProfilePage() {
  return h('div', { class: 'page active' },
    Card(
      h('div', { class: 'unavailable-page' },
        h('div', { class: 'unavailable-icon' }, svgUse('ic-user')),
        h('h1', {}, t('notAvailableYet')),
        h('p', {}, t('notAvailableDesc')),
      ),
    ),
    h('p', { class: 'tagline-strip' }, t('tagline')),
  );
}
